module.exports = __webpack_public_path__ + "static/media/5.536e2972.svg";